import { LogtoStateKey } from "../utils/constants.mjs";
import { shallowRef as shallowReference, useNuxtApp, useState } from "#imports";
export default function useLogtoUser() {
  const nuxtApp = useNuxtApp();
  const user = useState(
    LogtoStateKey.User,
    () => shallowReference(nuxtApp.ssrContext?.event.context.logtoUser)
  );
  return user.value;
}
